import React from "react";
import "./Privacy_Policy.css";
// import Header from "../../Header/Header";

const Privacy_Policy = ({ onClose }) => {
  return (
    <div className="PP_Page">
      {/* <Header /> */}

      <div className="PP_Body">
        <h1 className="PP_Title">COPYRIGHT &amp; MUSIC POLICY</h1>
        <br />
        <h3 className="PP_Updated">
          Effective Date: 06-August-2026
        </h3>

        <h3 className="PP_Updated"> Last Updated: 06-August-2026</h3>

        <p>
          This Copyright &amp; Music Policy ("Policy") applies to the use of
          BOLO-INDIA MEDIA, including its mobile application, website and
          related services (collectively, the "Platform"), operated by <b>BOLO-INDIA MEDIA NETWORKS PRIVATE LIMITED</b>
           ("Company", "we", "us" or
          "our").
        </p>

        <p>
          This Policy forms part of, and should be read together with the
          Platform's <b>Terms of Use/User Agreement, Privacy Policy and Community
            Guidelines.</b>
        </p>

        <p>
          The purpose of this Policy is to protect creators and rightsholders
          while enabling users to create, share and discover original content.
        </p>

        <h2>1. OUR COPYRIGHT PRINCIPLE</h2>

        <p>
          BOLO-INDIA MEDIA respects intellectual-property rights.
        </p>

        <p>
          Users must upload, post, livestream, share or otherwise make
          available only content that:
        </p>

        <ul>
          <li>they created themselves;</li>
          <li>they own;</li>
          <li>they are authorised or licensed to use; or</li>
          <li>they are otherwise legally entitled to use.</li>
        </ul>

        <p>
          The fact that content is publicly available on the internet does not
          necessarily mean that it is free to copy, upload, modify or
          commercially exploit.
        </p>

        <h2>2. APPLICABLE LAW</h2>

        <p>
          This Policy is intended to operate in accordance with applicable
          Indian law, including:
        </p>

        <ul>
          <li>The <b>Copyright Act, 1957</b>, as amended;</li>
          <li>The <b>Copyright Rules, 2013</b>, as amended;</li>
          <li>The <b>Information Technology Act, 2000;</b></li>
          <li>
            Applicable provisions of the <b>Information Technology (Intermediary
            Guidelines and Digital Media Ethics Code) Rules, 2021,</b> as amended;
          </li>
          <li>
            Other applicable laws, judicial orders and governmental directions.
          </li>
        </ul>

        <p>
          Nothing in this Policy limits any right, defence, exception or remedy
          available under applicable law.
        </p>

        <h2>3. WHAT COPYRIGHT MAY PROTECT</h2>

        <p>
          Copyright may subsist in various types of content made available
          through the Platform, including:
        </p>

        <ul>
          <li>Music and musical compositions</li>
          <li>Lyrics</li>
          <li>Sound recordings</li>
          <li>Films</li>
          <li>Videos</li>
          <li>Photographs</li>
          <li>Artwork</li>
          <li>Graphics</li>
          <li>Animations</li>
          <li>Written content</li>
          <li>Software</li>
          <li>Broadcasts</li>
          <li>Other copyright-protected works</li>
        </ul>

        <p>
          Different copyright interests may exist in the same piece of content.
        </p>

        <h2>4. MUSIC RIGHTS</h2>

        <p>
          Music can involve multiple separate rights and rightsholders.
        </p>

        <p>
          For example, a commercially released song may involve rights relating
          to:
        </p>

        <ul>
          <li>
            <strong>Musical Composition</strong>
            <br />
            Rights in the melody, musical arrangement or composition.
          </li>

          <li>
            <strong>Lyrics</strong>
            <br />
            Rights in the words of the song.
          </li>

          <li>
            <strong>Sound Recording / Master</strong>
            <br />
            Rights in the particular recorded version of the song.
          </li>

          <li>
            <strong>Performers' Rights</strong>
            <br />
            Rights of singers, musicians and other performers, where applicable.
          </li>

          <li>
            <strong>Synchronisation and Audiovisual Use</strong>
            <br />
            Using music together with video may require appropriate rights or
            permissions depending on the circumstances.
          </li>
        </ul>

        <p>
          Accordingly, permission from one person or organisation does not
          necessarily grant all rights necessary to use a particular song on the
          Platform.
        </p>
        <h2>5. PLATFORM MUSIC LIBRARY</h2>

        <p>
          BOLO-INDIA MEDIA may provide users access to a library of songs,
          sounds, audio clips, effects or other music ("Platform Music
          Library").
        </p>

        <p>
          Music made available through the Platform Music Library may be subject
          to agreements between the Company and relevant:
        </p>

        <ul>
          <li>Record labels</li>
          <li>Music publishers</li>
          <li>Copyright societies</li>
          <li>Composers</li>
          <li>Lyricists</li>
          <li>Performers</li>
          <li>Music distributors</li>
          <li>Independent artists</li>
          <li>Other rightsholders</li>
        </ul>

        <p>
          Availability may vary according to territory, account type, content
          type and intended use.
        </p>

        <h2>6. USE OF PLATFORM-LICENSED MUSIC</h2>

        <p>
          Users may use music from the Platform Music Library only:
        </p>

        <ul className="number-list">
          <li>1. Through functionality provided by BOLO-INDIA MEDIA.</li>
          <li>2. Within permitted territories.</li>
          <li>3. Within permitted duration limits.</li>
          <li>4. For permitted content formats.</li>
          <li>
            5. For personal or commercial use only where the applicable licence
            permits it.
          </li>
          <li>
            6. Subject to restrictions communicated through the Platform.
          </li>
        </ul>

        <p>
          Users must not extract, download, redistribute or separately exploit
          music from the Platform Music Library except where expressly
          permitted.
        </p>

        <p>
          The Company may change or withdraw music where licensing arrangements
          change, expire or terminate.
        </p>

        <h2>7. BUSINESS AND COMMERCIAL USE OF MUSIC</h2>

        <p>
          Music cleared for ordinary user-generated content may <b>not necessarily
            be cleared for commercial use</b>.
        </p>

        <p>
          Business accounts, advertisers, brands, influencers and creators
          producing commercial content must ensure that they possess appropriate
          rights for music used in:
        </p>

        <ul>
          <li>Advertisements</li>
          <li>Sponsored content</li>
          <li>Paid partnerships</li>
          <li>Brand promotions</li>
          <li>Product placements</li>
          <li>Commercial campaigns</li>
          <li>Promotional videos</li>
          <li>Other commercial communications</li>
        </ul>

        <p>
          BOLO-INDIA MEDIA may provide a separate commercial music library or
          restrict certain songs from commercial accounts.
        </p>

        <h2>8. USER-UPLOADED MUSIC</h2>

        <p>
          Users may be permitted to upload original audio or videos containing
          music independently of the Platform Music Library.
        </p>

        <p>
          By doing so, the user represents and warrants that they possess all
          necessary rights, licences, permissions and consents required for that
          use.
        </p>

        <p>
          Users should not upload commercial songs merely because they:
        </p>

        <ul>
          <li>Purchased the song;</li>
          <li>Downloaded it legally;</li>
          <li>Subscribe to a music-streaming service;</li>
          <li>Own a physical copy;</li>
          <li>Credited the artist;</li>
          <li>Used only part of the song;</li>
          <li>Did not monetise the video; or</li>
          <li>Found the music elsewhere online.</li>
        </ul>

        <p>
          None of those circumstances automatically establishes that the user
          has the rights required to upload or communicate the music through
          BOLO-INDIA MEDIA.
        </p>

        <h2>9. ORIGINAL MUSIC BY USERS</h2>

        <p>
          Users may upload music they have created themselves. However, users
          should ensure that they control all relevant rights.
        </p>

        <p>
          For example, a song may involve multiple contributors such as:
        </p>

        <ul>
          <li>Composer</li>
          <li>Lyricist</li>
          <li>Singer</li>
          <li>Producer</li>
          <li>Musicians</li>
          <li>Record Label</li>
          <li>Publisher</li>
        </ul>

        <p>
          A user uploading original music must ensure that all necessary
          contributor permissions have been obtained.
        </p>

        <h2>10. COVER SONGS, REMIXES, MASHUPS AND SAMPLES</h2>

        <p>
          Cover songs, remixes, mashups, sampled recordings and derivative
          musical content may involve third-party rights.
        </p>

        <p>
          Creating a new recording does not necessarily eliminate rights in the
          underlying musical or literary work.
        </p>

        <p>
          Users are responsible for ensuring that their use is authorised or
          otherwise permitted under applicable law.
        </p>

        <h2>11. FILM, TELEVISION AND OTT CONTENT</h2>

        <p>
          Users must not upload unauthorised copies or protected portions of:
        </p>

        <ul>
          <li>Films;</li>
          <li>Television programmes;</li>
          <li>OTT programmes;</li>
          <li>Web series;</li>
          <li>Documentaries;</li>
          <li>Music videos;</li>
          <li>Sports broadcasts;</li>
          <li>Concerts;</li>
          <li>News broadcasts;</li>
          <li>Subscription content; or</li>
          <li>Other protected audiovisual works.</li>
        </ul>

        <p>
          Screen-recording or recording content from another service does not give the
          user ownership of that content.
        </p>

        <h2>12. PHOTOGRAPHS AND IMAGES</h2>

        <p>
          Users should upload photographs and images only where they possess the
          necessary rights or lawful authority.
        </p>

        <p>
          Credit to a photographer or source does not, by itself, constitute copyright
          permission.
        </p>

        <h2>13. FAIR DEALING AND OTHER LEGAL EXCEPTIONS</h2>

        <p>
          Indian copyright law recognises certain exceptions and limitations to
          copyright, including fair dealing in circumstances specified by law.
        </p>

        <p>
          Whether a particular use qualifies for an exception depends on the specific
          facts and applicable law.
        </p>

        <p>
          The Company does not determine that every use of short clips, commentary,
          criticism, review, parody, news material or educational material is
          automatically lawful merely because a user characterises it as "fair use" or
          "fair dealing".
        </p>

        <p>
          Users relying on an exception remain responsible for their use.
        </p>

        <h2>14. CONTENT IDENTIFICATION AND RIGHTS MANAGEMENT</h2>

        <p>
          BOLO-INDIA MEDIA may use automated and manual systems to identify potentially
          copyrighted material.
        </p>

        <p>These may include:</p>

        <ul>
          <li>Audio fingerprinting;</li>
          <li>Video matching;</li>
          <li>Hash matching;</li>
          <li>Metadata analysis;</li>
          <li>Artificial intelligence;</li>
          <li>Rightsholder reference databases;</li>
          <li>Human moderation; and</li>
          <li>User/rightsholder reports.</li>
        </ul>

        <p>
          A match does not necessarily establish infringement, and the Company may
          provide appropriate review or dispute mechanisms.
        </p>

        <h2>15. ACTIONS WE MAY TAKE</h2>

        <p>
          Where content is identified as potentially unauthorised, BOLO-INDIA MEDIA
          may, depending on applicable law, contractual obligations and circumstances:
        </p>

        <ul>
          <li>Mute the audio;</li>
          <li>Replace the audio;</li>
          <li>Restrict the content in certain territories;</li>
          <li>Block uploading;</li>
          <li>Disable sharing;</li>
          <li>Restrict recommendation/distribution;</li>
          <li>Disable monetisation;</li>
          <li>Redirect monetisation where contractually applicable;</li>
          <li>Remove the content;</li>
          <li>Disable access to the content;</li>
          <li>Issue a copyright warning;</li>
          <li>Restrict account features;</li>
          <li>Suspend an account; or</li>
          <li>Terminate an account.</li>
        </ul>

        <h2>16. COPYRIGHT COMPLAINT / TAKEDOWN PROCEDURE</h2>

        <p>
          A copyright owner or authorised representative who believes that
          content on BOLO-INDIA MEDIA infringes copyright may submit a copyright
          complaint.
        </p>

        <p>
          <strong>Copyright Contact</strong>
          <br />
          Copyright / Grievance Officer
          <br />
          Email:{" "}
          <a href="mailto:grievances@boloindia.com">
            grievances@boloindia.com
          </a>
          <br />
          Postal Address:
          <br />
          122, Narasimha, C-Wing, 3rd Main,
          <br />
          Gruhalakshmi Layout 2nd Stage,
          <br />
          Kamalanagar,
          <br />
          Bangalore – 560079,
          <br />
          Karnataka, India.
        </p>

        <p>
          A complaint should contain sufficient information for the Company to
          identify and evaluate the claim.
        </p>

        <h2>17. INFORMATION REQUIRED IN A COPYRIGHT COMPLAINT</h2>

        <p>
          The complainant should provide the following information:
        </p>

        <h3>A. Rightsholder Details</h3>

        <ul>
          <li>Full legal name</li>
          <li>Organisation / Company (if applicable)</li>
          <li>Email address</li>
          <li>Telephone number</li>
          <li>Postal address</li>
        </ul>

        <h3>B. Copyrighted Work</h3>

        <p>
          A clear description of the copyrighted work claimed to have been
          infringed.
        </p>

        <p>Where possible, provide:</p>

        <ul>
          <li>Title</li>
          <li>Author / Creator</li>
          <li>Copyright owner</li>
          <li>Registration details (if available)</li>
          <li>Original publication information</li>
          <li>An authorised example or source</li>
        </ul>

        <h3>C. Infringing Material</h3>

        <p>
          Provide sufficient information to identify the allegedly infringing
          content, such as:
        </p>

        <ul>
          <li>BOLO-INDIA MEDIA URL</li>
          <li>Post / Video ID</li>
          <li>Username / Account</li>
          <li>Screenshot</li>
          <li>Description of the allegedly infringing material</li>
        </ul>

        <h3>D. Ownership or Authority</h3>

        <p>Explain whether you are:</p>

        <ul>
          <li>The copyright owner</li>
          <li>An authorised agent</li>
          <li>An exclusive licensee</li>
          <li>Otherwise legally authorised to submit the complaint</li>
        </ul>

        <p>
          Evidence of authority may be requested.
        </p>

        <h3>E. Good-Faith Statement</h3>

        <p>
          The complaint should include a statement substantially as follows:
        </p>

        <p>
          "I believe in good faith that the use of the copyrighted material
          described in this complaint is not authorised by the copyright owner,
          its authorised representative, or applicable law."
        </p>

        <h3>F. Accuracy Statement</h3>

        <p>
          The complainant should confirm that the information provided is
          accurate and that they are authorised to act in relation to the
          copyright concerned.
        </p>

        <h3>G. Signature</h3>

        <p>
          The complaint should contain an electronic or physical signature of
          the complainant or authorised representative.
        </p>

        <h2>18. PROCESS AFTER RECEIVING A COMPLAINT</h2>

        <p>
          Upon receiving a sufficiently complete copyright complaint,
          BOLO-INDIA MEDIA may:
        </p>

        <ul className="number-list">
          <li>1. Acknowledge receipt.</li>
          <li>2. Review whether sufficient information has been supplied.</li>
          <li>3. Request additional information.</li>
          <li>4. Identify the reported content.</li>
          <li>5. Preserve relevant records where appropriate.</li>
          <li>6. Restrict or disable access where required.</li>
          <li>
            7. Notify the affected user where legally and operationally
            appropriate.
          </li>
          <li>
            8. Provide information regarding available dispute or
            counter-notice procedures.
          </li>
          <li>9. Take further action required by applicable law.</li>
        </ul>

        <p>
          Incomplete, fraudulent, abusive or unsupported complaints may not be
          acted upon.
        </p>

        <h2>19. EMERGENCY OR COURT-ORDERED REMOVAL</h2>

        <p>
          Where the Company receives a legally binding court order,
          governmental direction or other lawful order requiring action
          concerning content, it will process the request in accordance with
          applicable Indian law.
        </p>

        <p>
          Nothing in the ordinary copyright-reporting process limits the
          Company's obligation to comply with binding legal requirements.
        </p>

        <h2>20. NOTICE TO THE USER</h2>

        <p>
          Where content is removed or disabled following a copyright complaint,
          the Company may notify the affected user with information including:
        </p>

        <ul>
          <li>Identification of the removed content</li>
          <li>General nature of the copyright claim</li>
          <li>Claimant information where legally appropriate</li>
          <li>Action taken</li>
          <li>Consequences for the account</li>
          <li>Information concerning dispute or counter-notice procedures</li>
        </ul>

        <p>
          Information may be withheld where disclosure is prohibited by law or
          reasonably creates security, privacy or abuse risks.
        </p>

        <h2>21. COUNTER-NOTICE / COPYRIGHT APPEAL</h2>

        <p>
          If a user believes that content was removed or disabled because of:
        </p>

        <ul>
          <li>Mistake</li>
          <li>Misidentification</li>
          <li>Incorrect ownership claim</li>
          <li>An existing licence or permission</li>
          <li>A legally permitted use</li>
          <li>Another valid legal basis</li>
        </ul>

        <p>
          The user may submit a Copyright Counter-Notice / Appeal.
        </p>

        <p>
          <strong>Submit Counter-Notice To:</strong>
          <br />
          Copyright / Grievance Officer
          <br />
          Email:{" "}
          <a href="mailto:grievances@boloindia.com">
            grievances@boloindia.com
          </a>
        </p>

        <h2>22. INFORMATION REQUIRED IN COUNTER-NOTICE</h2>

        <p>
          The user should provide:
        </p>

        <ul className="number-list">
          <li>1. Full legal name</li>
          <li>2. Registered BOLO-INDIA MEDIA username</li>
          <li>3. Email address</li>
          <li>4. Telephone number where reasonably required</li>
          <li>5. Identification of the removed content</li>
          <li>6. URL or Post / Video ID</li>
          <li>7. Date of removal, if known</li>
          <li>8. Explanation of why the removal is believed to be incorrect</li>
          <li>
            9. Evidence of ownership, licence, authorisation or other lawful basis
            (where available)
          </li>
          <li>10. Electronic or physical signature</li>
        </ul>

        <p>
          The counter-notice should include a statement substantially as
          follows:
        </p>

        <p>
          "I believe in good faith that the content identified above was removed
          or disabled as a result of mistake, misidentification, an applicable
          licence, permission or other lawful basis. I confirm that the
          information in this counter-notice is accurate to the best of my
          knowledge."
        </p>

        <h2>23. COUNTER-NOTICE REVIEW</h2>

        <p>
          After receiving a counter-notice, BOLO-INDIA MEDIA may:
        </p>

        <ul>
          <li>Review the counter-notice</li>
          <li>Request additional information</li>
          <li>Seek clarification from the original complainant</li>
          <li>Review evidence provided by both parties</li>
          <li>Maintain the restriction while the dispute is evaluated</li>
          <li>Restore the content where appropriate</li>
          <li>Maintain removal where the claim remains sufficiently supported</li>
          <li>
            Require the parties to resolve ownership issues through appropriate
            legal processes
          </li>
        </ul>

        <p>
          BOLO-INDIA MEDIA is not a court and is generally not in a position to
          adjudicate complex copyright ownership disputes.
        </p>

        <p>
          Where ownership is genuinely contested and cannot reasonably be
          determined from available information, the Company may maintain
          appropriate restrictions pending legal resolution.
        </p>

        <h2>24. RESTORATION OF CONTENT</h2>

        <p>
          Where the Company determines that content was removed because of an
          error, misidentification, withdrawn complaint or other sufficient
          basis, it may restore the content and remove or adjust any associated
          copyright strike.
        </p>

        <p>
          Restoration does not constitute a legal determination that the content
          is non-infringing.
        </p>

        <h2>25. CLAIMANT RESPONSE TO COUNTER-NOTICE</h2>

        <p>
          Where appropriate, the Company may notify the original complainant
          that a counter-notice has been received.
        </p>

        <p>
          The claimant may be asked to provide additional evidence or
          information concerning legal proceedings where relevant.
        </p>

        <p>
          Where a binding court order or other legal requirement prevents
          restoration, the Company will comply with applicable law.
        </p>

        <h2>26. COPYRIGHT STRIKE SYSTEM</h2>

        <p>
          BOLO-INDIA MEDIA may operate a copyright-strike system.
        </p>

        <p>
          A valid copyright removal may result in a copyright strike against the
          relevant account.
        </p>

        <p>
          Depending on severity and frequency, consequences may include:
        </p>

        <ul>
          <li>
            <strong>First Violation</strong>
            <br />
            Copyright warning, content removal and copyright education.
          </li>

          <li>
            <strong>Repeated Violations</strong>
            <br />
            Additional strikes, temporary restrictions, loss of monetisation or
            reduced functionality.
          </li>

          <li>
            <strong>Serious or Repeated Infringement</strong>
            <br />
            Account suspension or permanent termination.
          </li>
        </ul>

        <p>
          The Company may take immediate action for serious infringement without
          applying progressive warnings.
        </p>

        <p>
          Successfully disputed claims may result in corresponding strikes being
          removed.
        </p>

        <h2>27. REPEAT INFRINGER POLICY</h2>

        <p>
          BOLO-INDIA MEDIA may suspend or terminate users who repeatedly
          infringe third-party intellectual-property rights.
        </p>

        <p>
          When determining appropriate action, the Company may consider:
        </p>

        <ul>
          <li>Number of valid complaints</li>
          <li>Seriousness of infringement</li>
          <li>Frequency of infringement</li>
          <li>User's response</li>
          <li>Successful counter-notices</li>
          <li>Fraudulent claims</li>
          <li>Pattern of conduct</li>
          <li>Applicable legal requirements</li>
        </ul>

        <h2>28. FRAUDULENT COPYRIGHT CLAIMS</h2>

        <p>
          Users and rightsholders must not misuse the copyright-reporting
          system.
        </p>

        <p>Prohibited misuse includes:</p>

        <ul>
          <li>Knowingly false copyright claims</li>
          <li>Impersonating a rightsholder</li>
          <li>Submitting forged documents</li>
          <li>
            Using copyright complaints to silence legitimate criticism
          </li>
          <li>
            Knowingly claiming ownership of material belonging to another
            person
          </li>
          <li>Repeatedly filing abusive complaints</li>
          <li>Intentionally providing materially false information</li>
        </ul>

        <p>
          The Company may restrict access to its reporting systems, suspend
          accounts or take other appropriate action against abusive claimants.
        </p>

        <p>
          False claims may also expose the claimant to liability under
          applicable law.
        </p>

        <h2>29. COPYRIGHT DISPUTES BETWEEN USERS</h2>

        <p>
          BOLO-INDIA MEDIA may facilitate communication and provide reporting
          mechanisms but does not acquire ownership of User Content merely by
          hosting it.
        </p>

        <p>
          Complex disputes concerning authorship, licences, assignments,
          royalty entitlement or ownership may need to be resolved between the
          parties or by an appropriate court or authority.
        </p>

        <p>
          The Company may comply with legally binding decisions concerning such
          disputes.
        </p>

        <h2>30. MUSIC RIGHTS MANAGEMENT FOR RIGHTSHOLDERS</h2>

        <p>
          Music labels, publishers, copyright societies, distributors and
          independent rightsholders may contact BOLO-INDIA MEDIA regarding
          rights-management arrangements.
        </p>

        <p>
          Depending on Platform capabilities, eligible rightsholders may be
          offered tools to:
        </p>

        <ul>
          <li>Register reference content</li>
          <li>Identify matching uploads</li>
          <li>Request blocking</li>
          <li>Request muting</li>
          <li>Request takedown</li>
          <li>Establish territorial restrictions</li>
          <li>Manage authorised content</li>
          <li>Access reporting information</li>
        </ul>

        <p>
          Availability of such tools is determined by the Company.
        </p>

        <h2>31. MUSIC LICENSING DOES NOT TRANSFER OWNERSHIP</h2>

        <p>
          Where BOLO-INDIA MEDIA enters into licences with music
          rightsholders, those licences do not transfer ownership of the music
          to BOLO-INDIA MEDIA.
        </p>

        <p>
          Users receive only the limited ability to use licensed music through
          Platform features and subject to applicable licence conditions.
        </p>

        <h2>32. CREATOR RESPONSIBILITIES</h2>

        <p>
          Creators are responsible for obtaining necessary rights for
          independently uploaded:
        </p>

        <ul>
          <li>Background music</li>
          <li>Beats</li>
          <li>Samples</li>
          <li>Stock footage</li>
          <li>Movie clips</li>
          <li>Photographs</li>
          <li>Memes</li>
          <li>Graphics</li>
          <li>Sound effects</li>
          <li>Other third-party content</li>
        </ul>

        <p>
          Monetisation does not reduce copyright obligations and may require
          additional commercial permissions.
        </p>

        <h2>33. BRAND AND ADVERTISER RESPONSIBILITIES</h2>

        <p>
          Advertisers and brands must ensure that content used in campaigns is
          properly cleared.
        </p>

        <p>
          This includes appropriate rights relating to:
        </p>

        <ul>
          <li>Music</li>
          <li>Photographs</li>
          <li>Videos</li>
          <li>Trademarks</li>
          <li>Talent</li>
          <li>Models</li>
          <li>Performers</li>
          <li>Other third-party intellectual property</li>
        </ul>

        <p>
          Advertisers should maintain evidence of licences and permissions and
          provide such evidence to BOLO-INDIA MEDIA where reasonably requested.
        </p>

        <h2>34. LIVESTREAM COPYRIGHT</h2>

        <p>
          Copyright rules apply equally to livestreaming. Users must not
          livestream unauthorised:
        </p>

        <ul>
          <li>Films</li>
          <li>Television broadcasts</li>
          <li>Sporting events</li>
          <li>Concerts</li>
          <li>Music</li>
          <li>Subscription broadcasts</li>
          <li>Other copyrighted transmissions</li>
        </ul>

        <p>
          BOLO-INDIA MEDIA may interrupt or terminate livestreams where
          potentially unauthorised copyrighted material is detected or
          reported.
        </p>

        <h2>35. MUSIC IN THE BACKGROUND</h2>

        <p>
          The fact that music is playing incidentally or intentionally in the
          background of a recording does not automatically mean that its use is
          legally authorised.
        </p>

        <p>
          Users should consider whether necessary rights or legal exceptions
          apply before uploading such recordings.
        </p>

        <h2>36. ATTRIBUTION IS NOT A SUBSTITUTE FOR PERMISSION</h2>

        <p>
          Statements such as:
        </p>

        <ul>
          <li>"Copyright belongs to the owner"</li>
          <li>"No copyright infringement intended"</li>
          <li>"Credits to the original creator"</li>
          <li>"For entertainment purposes only"</li>
          <li>or similar disclaimers</li>
        </ul>

        <p>
          Do not, by themselves, create permission to use copyrighted content.
        </p>

        <h2>37. DOWNLOADING AND REPOSTING OTHER USERS' CONTENT</h2>

        <p>
          Users must not download another user's content and repost it as their
          own without appropriate permission or other lawful basis.
        </p>

        <p>
          The Platform's native share/repost functionality should be used where
          available because it can preserve attribution and links to the
          original content.
        </p>

        <h2>38. AI-GENERATED AND AI-MODIFIED MUSIC</h2>

        <p>
          Users creating or uploading AI-generated or AI-modified audio must
          ensure that their use does not violate applicable copyright,
          performers' rights, contractual rights or Platform rules.
        </p>

        <p>
          Users must not use AI tools to deliberately circumvent
          copyright-detection or rights-management systems.
        </p>

        <p>
          Where required, BOLO-INDIA MEDIA may label AI-generated or materially
          altered content.
        </p>

        <h2>39. NO CIRCUMVENTION</h2>

        <p>
          Users must not attempt to bypass:
        </p>

        <ul>
          <li>Audio fingerprinting</li>
          <li>Video matching</li>
          <li>Copyright filters</li>
          <li>Music duration restrictions</li>
          <li>Geographic restrictions</li>
          <li>Monetisation restrictions</li>
          <li>Other copyright-protection mechanisms</li>
        </ul>

        <p>
          Deliberate circumvention may result in account restrictions or
          termination.
        </p>

        <h2>40. COPYRIGHT REPORTING TIMELINES</h2>

        <p>
          BOLO-INDIA MEDIA will process copyright complaints, grievances and
          legally binding removal requirements within timelines required under
          applicable Indian law.
        </p>

        <p>
          Different categories of complaints may be subject to different
          statutory timelines.
        </p>

        <p>
          Nothing in this Policy should be interpreted as extending a shorter
          period mandated by applicable law.
        </p>

        <h2>41. GRIEVANCE REDRESSAL</h2>

        <p>
          Copyright-related grievances may be submitted to:
        </p>

        <p>
          <strong>Grievance Officer</strong>
          <br />
          Designation: Grievance Redressal Officer (GRO)
          <br />
          Email:{" "}
          <a href="mailto:grievances@boloindia.com">
            grievances@boloindia.com
          </a>
        </p>

        <p>
          The Company will acknowledge and process grievances in accordance
          with applicable Indian law.
        </p>

        <p>
          Where additional appellate or grievance mechanisms apply under Indian
          law, users may exercise those remedies.
        </p>

        <h2>42. CHANGES TO THIS POLICY</h2>

        <p>
          The Company may update this Policy where necessary because of:
        </p>

        <ul>
          <li>Changes in Indian copyright law</li>
          <li>Judicial decisions</li>
          <li>Regulatory requirements</li>
          <li>Music licensing arrangements</li>
          <li>Platform functionality</li>
          <li>Technology changes</li>
          <li>Operational requirements</li>
        </ul>

        <p>
          Material changes will be communicated where required by applicable
          law.
        </p>

        <h2>43. GOVERNING LAW</h2>

        <p>
          These Terms are governed by the laws of India.
        </p>

        <p>
          Subject to applicable consumer-protection law and other mandatory
          jurisdictional requirements, courts at Bangalore, Karnataka, India
          will have exclusive jurisdiction over disputes arising from these
          Terms, excluding all other courts in the world.
        </p>

        <h2>44. USER ACKNOWLEDGEMENT</h2>

        <p>
          By using BOLO-INDIA MEDIA, you acknowledge that:
        </p>

        <ul className="number-list">
          <li>
            1. Creators and rightsholders retain their intellectual-property
            rights.
          </li>
          <li>
            2. You are responsible for ensuring that you have appropriate rights
            to the content you upload.
          </li>
          <li>
            3. Purchasing or subscribing to music does not automatically give you
            the right to upload that music.
          </li>
          <li>
            4. Crediting a creator does not automatically constitute permission.
          </li>
          <li>
            5. BOLO-INDIA MEDIA may remove, mute, restrict or block content where
            necessary.
          </li>
          <li>
            6. Repeated copyright infringement may result in account termination.
          </li>
          <li>
            7. Copyright owners and users may use the complaint and
            counter-notice procedures described in this Policy.
          </li>
        </ul>
        <b><p>© 2026 Bolo-India Media Networks Private Limited. All rights reserved.</p></b>
      </div>
    </div>
  );
};

export default Privacy_Policy;
